<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px;border-radius: 10px;">

      <div class="">
        <div class="row">
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
            <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter the ATC Class or Active Ingredient
            </p>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
            <i class="fa fa-search icon" style="margin-right: 10px;"></i>
            <input class="w-75" placeholder="Enter the ATC Class or Active Ingredient" [(ngModel)]="searchValue"
              (keydown.enter)="searchMolecule()" autofocus>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
          </div>

        </div>

      </div>
    </div>
    <table class="table table-striped table-bordered text-center">
      <thead>
        <tr>
          <th scope="col" style="font-weight: bold">Brand Name</th>
          <th scope="col" style="font-weight: bold">Approval Date</th>
          <th scope="col" style="font-weight: bold">Generic name</th>
          <th scope="col" style="font-weight: bold">Category</th>
          <th scope="col" style="font-weight: bold">Innovator</th>
          <th scope="col" style="font-weight: bold"> RoA</th>
          <th scope="col" style="font-weight: bold">Dosage form</th>
          <th scope="col" style="font-weight: bold">Time from launch (Yrs)</th>
          <th scope="col" style="font-weight: bold">Genericized?</th>
          <th scope="col" style="font-weight: bold">Novel Polymorph</th>
          <th scope="col" style="font-weight: bold">NCE-1 passed?</th>
          <th scope="col" style="font-weight: bold">Actual Price in market in Jan 2023</th>
          <th scope="col" style="font-weight: bold">Strength(mg)</th>
          <th scope="col" style="font-weight: bold">Pack Size (no)</th>
          <th scope="col" style="font-weight: bold">Pack price (USD)</th>
          <th scope="col" style="font-weight: bold">Discounted price (USD)</th>
          <th scope="col" style="font-weight: bold">Per unit price (USD)</th>
          <th scope="col" style="font-weight: bold">Per mg price (USD)</th>
          <th scope="col" style="font-weight: bold">average Price (USD per mg)</th>
          <th scope="col" style="font-weight: bold">Price relaisation (USD per Kg)</th>
          <th scope="col" style="font-weight: bold">Time from launch</th>
          <th scope="col" style="font-weight: bold">Genericized?</th>
          <th scope="col" style="font-weight: bold">Novel Polymorph</th>
          <th scope="col" style="font-weight: bold">NCE-1 passed?</th>
          <th scope="col" style="font-weight: bold">before NCE-1 Date</th>
          <th scope="col" style="font-weight: bold">After NCE-1 Date</th>
          <th scope="col" style="font-weight: bold">db api price</th>
          <th scope="col" style="font-weight: bold">Save button</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let company of allMoleculeData; index as i;">
          <tr>
            <td>
              {{ company['Brand name'] || '-' }}
            </td>
            <td>
              {{ company['Approval Year'] || '-'}}
            </td>
            <td>
              {{ company['Generic name'] || '-'}}
            </td>
            <td>
              {{ company['Category'] || '-'}}
            </td>
            <td>
              {{ company['Innovator'] || '-'}}
            </td>
            <td>
              {{ company['Route of Administration'] || '-'}}
            </td>
            <td>
              {{ company['Dosage form'] || '-'}}
            </td>
            <td>
              {{ company['Time from launch (Yrs)'] || '-'}}
            </td>
            <td>
              {{ company['Genericized?(YES/NO)'] || '-'}}
            </td>
            <td>
              <select (change)="onSelected($event, i)">
                <option value="-" disabled>-</option>
                <option value="YES">YES</option>
                <option value="NO" selected>NO</option>
              </select>
            </td>
            <td>
              {{ company['NCE-1 passed?(YES/NO)']}}
            </td>
            <td>
              {{ company['Actual Price(API Price) in market']}}
            </td>
            <td>
          <tr *ngFor="let data of company.Strengths">
            <td>{{data.Strength || '-'}}</td>
          </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['Pack Size'] || '-'}}</td>
            </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['Pack price'] || '-'}}</td>
            </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['new pack price'] || '-'}}</td>
            </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['new Per unt price'] || '-'}}</td>
            </tr>
          </td>
          <td>
            <tr *ngFor="let data of company.Strengths">
              <td>{{data['Per mg price'] || '-'}}</td>
            </tr>
          </td>
          <td>
            {{ company['average Price (USD per mg)'] || '-'}}
          </td>
          <td>
            {{ company['Price relaisation (USD per Kg)'] || '-'}}
          </td>
          <td>
            {{ company['Time from launch'] || '-'}}
          </td>
          <td>
            {{ company['Genericized?'] || '-'}}
          </td>
          <td>
            <div *ngIf="company.novelPolymorph == true">1.0</div>
            <!-- <div *ngIf="selectedvalue == 'YES' && company['NDA number'] != ndaId">0.5</div> -->
            <div *ngIf="company.novelPolymorph == false">0.5</div>
          </td>
          <td>
            {{ company['NCE-1 passed?'] || '-'}}
          </td>
          <td *ngIf="company['NCE-1 passed?(YES/NO)'] == 'YES'" [ngStyle]="{'background-color':'black',color:'white'}">
            {{company['before NCE-1 Date'] || '0'}}
          </td>
          <td *ngIf="company['NCE-1 passed?(YES/NO)'] == 'NO'">
            {{company['before NCE-1 Date'] || '0'}}
          </td>
          <td *ngIf="company['NCE-1 passed?(YES/NO)'] == 'N/A'">
            {{company['before NCE-1 Date'] || '0'}}
          </td>
          <td *ngIf="company['NCE-1 passed?(YES/NO)'] == 'NO'" [ngStyle]="{'background-color':'black',color:'white'}">
            {{company['After NCE-1 Date'] || '0'}}
          </td>
          <td *ngIf="company['NCE-1 passed?(YES/NO)'] == 'N/A'" [ngStyle]="{'background-color':'black',color:'white'}">
            {{company['After NCE-1 Date'] || '0'}}
          </td>
          <td *ngIf="company['NCE-1 passed?(YES/NO)'] == 'YES'">
            {{company['After NCE-1 Date'] || '0'}}
          </td>
          <td>
            {{ company['db api price'] || '-'}}
          </td>
          <td>
            <button *ngIf="company['save_btn'] =='YES'; else view"
              (click)="saveMolecule(company['NCE-1 passed?(YES/NO)'],company['before NCE-1 Date'],company['After NCE-1 Date'],company['NDA number'],company['Generic name']); savePolymorph(company['Novel Polymorph(YES/NO)'],company['NDA number'],company['Genericized?(YES/NO)'],searchValue,['NCE-1 passed?(YES/NO)'])">Save</button>
            <ng-template #view>
              -
            </ng-template>
          </td>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>